const samplePremuimReqBody = {
    "UserID": "AXN80DMdKYQ",
    "ApplicationNo": "AP785d41121377",
    "CustomerName": "Sai",
    "PlanNo": "106",
    "SumProposed": "100000",
    "PremiumFrequency": "1005",
    "PolicyTerm": "10",
    "Premium": "10000",
    "GST": "450",
    "PayableAmount": "10450",
    "MobileNo": "9140628469",
    "ReturnURL": ""
    }


const generatePayPremuimReqBody = (values,returnUrl) =>{
    console.log('generatePayPremuimReqBody',values,returnUrl)
     return {
        "UserID": values.Request.Proposal.UserID,
    "ApplicationNo": values.Request.Proposal.ApplicationNo,
    "CustomerName": `${values.Request.Proposal.Proposer.FirstName}${values.Request.Proposal.Proposer.MiddleName}${values.Request.Proposal.Proposer.LastName}`,
    "PlanNo": values.Request.Proposal.Plan.PlanNo,
    "SumProposed": values.Request.Proposal.Plan.SumProposed,
    "PremiumFrequency": values.Request.Proposal.Plan.PremiumFrequency,
    "PolicyTerm": values.Request.Proposal.Plan.PolicyTerm,
    "Premium": values.Request.Proposal.Plan.Premium,
    "GST": values.Request.Proposal.Plan.GST,
    "PayableAmount": values.Request.Proposal.Plan.TotalPremium,
    "MobileNo": values.Request.Proposal.Address[0].MobileNo,
    "ReturnURL": returnUrl
    } 
}

export default generatePayPremuimReqBody;